import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  HomeIcon, 
  DocumentTextIcon, 
  PhotoIcon, 
  CogIcon,
  NewspaperIcon,
  EyeIcon,
  ArrowLeftIcon
} from '@heroicons/react/24/outline';

const AdminNav = () => {
  const location = useLocation();

  const navigation = [
    { name: 'Dashboard', href: '/admin', icon: HomeIcon },
    { name: 'Content', href: '/admin/content', icon: DocumentTextIcon },
    { name: 'Images', href: '/admin/images', icon: PhotoIcon },
    { name: 'Blog', href: '/admin/blog', icon: NewspaperIcon },
    { name: 'Layout', href: '/admin/layout', icon: EyeIcon },
    { name: 'Settings', href: '/admin/settings', icon: CogIcon },
  ];

  return (
    <div className="bg-white dark:bg-naqd-dark-surface border-r border-naqd-light-border dark:border-naqd-dark-border min-h-screen">
      <div className="p-4">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-lg font-semibold text-naqd-light-text dark:text-naqd-dark-text">Admin Panel</h2>
          <Link 
            to="/" 
            className="text-naqd-primary dark:text-naqd-green hover:text-naqd-primary/80 dark:hover:text-naqd-green/80"
          >
            <ArrowLeftIcon className="w-5 h-5" />
          </Link>
        </div>
        
        <nav className="space-y-1">
          {navigation.map((item) => {
            const isActive = location.pathname === item.href;
            return (
              <Link
                key={item.name}
                to={item.href}
                className={`flex items-center space-x-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-naqd-primary text-white dark:bg-naqd-green dark:text-white'
                    : 'text-naqd-light-text-secondary dark:text-naqd-dark-text-secondary hover:bg-naqd-light-surface dark:hover:bg-naqd-dark-surface/50'
                }`}
              >
                <item.icon className="w-5 h-5" />
                <span>{item.name}</span>
              </Link>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default AdminNav;